import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Stats } from '../models/Stats';
import { StatsService } from './stats.service';
import { AccueilService } from '../accueil/accueil.service';
import { Syncro } from '../models/Syncro';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MainComponent } from "../main/main.component";
import { MatIconButton } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { NgxSpinnerComponent, NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-stats',
  imports: [
    CommonModule,
    MatCardModule,
    MatGridListModule,
    MatTableModule,
    MatProgressBarModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MainComponent,
    MatIconModule,
    MatExpansionModule,
    NgxSpinnerComponent
],
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.css',
})
export class StatsComponent implements OnInit {
  allSyncro: Syncro[] = [];
  selectedSyncro: Syncro = new Syncro();

  form: FormGroup;



  constructor(
    private fb: FormBuilder,
    public statsService: StatsService,
    public accueilService: AccueilService,
    public spinner: NgxSpinnerService
  ) {
    this.form = this.fb.group({
      syncro: [this.selectedSyncro]
    });
  }

  ngOnInit(): void {

    this.spinner.show();
    this.accueilService.getSyncros().subscribe((result) => {
      this.allSyncro = result;
      this.selectedSyncro = this.allSyncro[this.allSyncro.length - 1];
      this.statsService.getStats(this.selectedSyncro?.idSyncro).subscribe(result => {
        this.spinner.hide();
        this.stats = result;

      });
    }, error => {
      this.spinner.hide();
    });
    this.statsService;

    this.form.get('syncro')!.valueChanges.subscribe(() => {
      this.statsService.getStats(this.selectedSyncro?.idSyncro).subscribe(result => {
        this.stats = result;
      });
    });
  }

  stats?: Stats = new Stats();

  formatPercentage(value?: number): string {
    return value != null ? `${value.toFixed(1)} %` : '-';
  }

  formatNumber(value?: number): string {
    return value != null ? value.toLocaleString() : '-';
  }
}
